import {View} from "react-native";
import {useRouter} from "expo-router";
import {useSession} from "@/lib/auth/auth";
import ActionButton from "@/lib/components/ActionButton";
import {useProfile} from "@/lib/components/ProfileProvider";

export default function ProfileHeader() {
    const {session} = useSession();
    const router = useRouter();

    const {profile} = useProfile();

    if (!profile) {
        return null;
    }

    return (
        <View style={{flexDirection: "row", gap: 6}}>
            {<ActionButton
                onPress={() => router.push(`/u/profile/${profile.avatar.username}/share`)}
                height={34}
                border={false}
                icon={"share"}
            />}
            {!!session && session.user_id === profile.avatar.id && <ActionButton
                onPress={() => router.push(`/u/account/edit`)}
                height={34}
                border={false}
                icon={"edit"}
            />}
        </View>
    )
}